var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRedAgent03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2969 24.7065L1.60286 0L0 1.59033L3.69408 5.28442C2.02451 7.45738 1.11785 10.1201 1.11449 12.8604C1.11449 19.7477 6.74953 25.3827 13.6368 25.3827C16.4919 25.3827 19.1091 24.4185 21.2128 22.8032L24.7065 26.2969L26.2969 24.7065ZM13.6368 22.8783C8.10194 22.8783 3.61895 18.3953 3.61895 12.8604C3.61895 10.6941 4.3202 8.70301 5.4973 7.07511L19.4221 20.9999C17.7436 22.2274 15.7163 22.8856 13.6368 22.8783ZM8.84076 4.05723L7.02502 2.21645C8.94094 1.03935 11.2075 0.338103 13.6368 0.338103C20.5241 0.338103 26.1591 5.97315 26.1591 12.8604C26.1591 15.2898 25.4579 17.5563 24.2808 19.4722L22.44 17.6565C23.2164 16.2289 23.6547 14.601 23.6547 12.8604C23.6547 7.32556 19.1717 2.84257 13.6368 2.84257C11.8962 2.84257 10.2683 3.28085 8.84076 4.05723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedAgent03);
export default __webpack_public_path__ + "static/media/icon-red-agent-03.5057c59783a07c0a9fe358bd6ad5f042.svg";
export { ForwardRef as ReactComponent };